import React, { useState, useEffect, useContext } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Button,
  Form,
  Row,
  Col,
  FormGroup,
  Input,
  CustomInput,
  Label,
} from "reactstrap";
import withRedirect from "../../hoc/withRedirect";
import AuthService from "../../services/authenticationService";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import AppContext from "../../context/Context";
import CryptoJS from "crypto-js";
import AuthSplitLayout from "./AuthSplitLayout";
import bgImage from "../../assets/img/logos/api-award-2022.jpg";
import Divider from "../common/Divider";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Image } from "react-bootstrap";
import APIReference from "../../assets/img/logos/login/API_Ref.png";
import APIStatus from "../../assets/img/logos/login/API_Status.png";
import API_Pricing_Image from "../../assets/img/logos/API_Pricing.png";
import SoftBadge from "../common/SoftBadge";
import Flex from "../common/Flex";
import Avatar from "../common/Avatar";
import AuthCardLayout from "./AuthCardLayout";
import { detect } from "detect-browser";
import authHeader from "../../services/authenticationHeader";
import axios from "axios";
import apiURL from "../../services/apiURL";
import apiCall, { ip } from "../../services/apiCall";
import useAxios from "../../layouts/useAxios";
import { useHistory } from "react-router-dom";

const browser = detect();
const API_URL = apiURL();
let keySize = 256;
let iterations = 100;
// const queryParameters = new URLSearchParams(window.location.search);
// const parmasUsername = queryParameters.get("username");
// const parmsPassword = queryParameters.get("password");
const LoginForm = ({ setRedirect, hasLabel, setRedirectUrl }) => {
  const {
    loginUserDetails,
    setLoginUserDetails,
    accessToken,
    setAccessToken,
    remember,
    setRemember,
    setRememberEmail,
    setRememberPass,
    setIsValidLogin,
    setLoginResponse,
  } = useContext(AppContext);

  const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false;

  const history = useHistory();
  // State
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loginApicalled, setLoginApicalled] = useState(false); //this is to prevent user from clicking login button multiple time
  const [rememberMeEmail, setRememberMeEmail] = useState();
  //
  // const [message, setMessage] = useState("");
  // const [loading, setLoading] = useState(false);

  function encrypt(msg, pass) {
    let salt = CryptoJS.lib.WordArray.random(128 / 8);

    let key = CryptoJS.PBKDF2(pass, salt, {
      keySize: keySize / 32,
      iterations: iterations,
    });

    let iv = CryptoJS.lib.WordArray.random(128 / 8);

    let encrypted = CryptoJS.AES.encrypt(msg, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });

    // salt, iv will be hex 32 in length
    // append them to the ciphertext for use  in decryption
    let transitmessage = salt.toString() + iv.toString() + encrypted.toString();
    return transitmessage;
  }

  function decrypt(transitmessage, pass) {
    let salt = CryptoJS.enc.Hex.parse(transitmessage.substr(0, 32));
    let iv = CryptoJS.enc.Hex.parse(transitmessage.substr(32, 32));
    let encrypted = transitmessage.substring(64);

    let key = CryptoJS.PBKDF2(pass, salt, {
      keySize: keySize / 32,
      iterations: iterations,
    });

    let decrypted = CryptoJS.AES.decrypt(encrypted, key, {
      iv: iv,
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    });
    return decrypted;
  }

  useEffect(() => {
    if (localStorage.getItem("remember")) {
      setRemember(true);
    }
  }, []);

  const postVisitLogs = () => {
    let loginEmail = `login using ${loginUserDetails?.user_name}`;
    const body = {
      dev_id: `${loginUserDetails?.dev_id}`,
      email_id: `${loginUserDetails?.user_name}`,
      dev_name: `${loginUserDetails?.dev_name}`,
      is_admin: loginUserDetails?.is_partner === "0" ? "yes" : "no",
      app_id: "",
      page_name: "Login",
      action_name: "Login",
      project_name: "API Portal v4.0",
      ip_address: ip ? ip : "",
      browser_name: `${browser?.name.charAt(0).toUpperCase() +
        browser?.name.slice(1)}`,
      browser_version: `${browser?.version}`,
      extra_comment: "insert | " + JSON.stringify({ login: loginEmail }),
      host_name: `${window.location.hostname}`,
    };

    axios
      .post(API_URL + "visit", body, { withCredentials: true })
      .then(() => {})
      .catch(() => {
        // localStorage.removeItem("actn");
        // localStorage.removeItem("lngst");
        // localStorage.removeItem("tempData");
        // window.location.assign(`${process.env.PUBLIC_URL}/authentication/login`);
      });
  };

  useEffect(() => {
    setRememberEmail(email);

    let encryptedPass = encrypt(password, "mysecretkey");
    setRememberPass(encryptedPass);

    if (remember && localStorage.getItem("remember")) {
      let emailAndPassFromLocalStorage = JSON.parse(
        localStorage.getItem("remember")
      );

      setEmail(emailAndPassFromLocalStorage.email);
      setPassword(
        decrypt(emailAndPassFromLocalStorage.password, "mysecretkey").toString(
          CryptoJS.enc.Utf8
        )
      );
    }
  }, []);

  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [isLoginSuccess, setIsLoginSuccess] = useState(false);
  // Handler
  const handleSubmit = (e) => {
    e.preventDefault();
    if (email != "" && password != "" && !loginApicalled) {
      setLoginApicalled(true);
      showLoader();

      let body = {
        username: email,
        password: password,
      };

      const isApiPlusExist = sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : null;
      if (isApiPlusExist) {
        body["redirect_url"] = isApiPlusExist["redirect_url"];
        body["callback_key"] = isApiPlusExist["callback_key"];
        body["request"] = isApiPlusExist["request"];
        body["project_id"] = isApiPlusExist["project_id"];
        body["source_project_id"] = isApiPlusExist["source_project_id"] ? isApiPlusExist["source_project_id"] : "";
      }

      AuthService.login(body).then(
        (res) => {
          localStorage.setItem("isLoggedIn", true);
          const tempSUD = {
            dev_name: res?.items?.dev_name,
            user_name: res?.items?.user_name,
            partner_name: res?.items?.partner_name,
          };
          setLoginResponse(res);
          setLoginUserDetails(res.items);

          // setIsValidLogin(true);

          if (localStorage.getItem("pageBeforeLoginHistory")) {
            setRedirectUrl(
              `${process.env.PUBLIC_URL}${localStorage
                .getItem("pageBeforeLoginHistory")
                .substring(7)}`
            );
          } else if (res.items.is_partner === "1") {
            if (isApiPlusExist) {
                if (res.items?.user_type?.toLowerCase() == "user") {
                  setRedirect(false);
                  toast.error("SAI is not permitted for users with Read-Only permissions. For access requests or further assistance, please contact the Sikka Administrator.");
                  setLoginApicalled(false);
                  hideLoader();
                  AuthService.logout(true,false);
                }else if (res.items?.is_2fa_enabled?.toLowerCase() == "no".toLowerCase()) {
                  // setRedirectUrl(`${process.env.PUBLIC_URL}/authentication/api-plus-payment`);
                  history.push({
                    pathname: `${
                      process.env.PUBLIC_URL
                    }/authentication/api-plus-payment`,
                    state: { email, password },
                  });
                  setRedirect(true);  
                }else{
                  localStorage.setItem("isLoggedIn", "false");
                  history.push({
                    pathname: `${
                      process.env.PUBLIC_URL
                    }/authentication/two-factor-authentication`,
                    state: { email, password },
                  });
                }          
              }
              else if (res.items.is_verified === "no") {
              setRedirectUrl(`${process.env.PUBLIC_URL}/user/verify`);
              setRedirect(true);
              toast.success(`Logged in as ${email}`);
            } else {
              if (res.items.dev_status.toLowerCase() !== "active") {
                toast.error(
                  "Your email id is already verified. Please contact Sikka API Support to get verified by Admin. Not allowed to log in."
                );
                AuthService.logout();
                setRedirectUrl(
                  `${process.env.PUBLIC_URL}/authentication/login`
                );
                setLoginApicalled(false);
                sessionStorage.removeItem("s_u_d");
              } else if (
                res.items.is_verified === "yes" &&
                res.items.nda_status.toLowerCase() === "sent" &&
                res.items.user_type.toLowerCase() == "super admin"
              ) {
                setRedirectUrl(`${process.env.PUBLIC_URL}/user/sign-nda`);
                setRedirect(true);
                toast.success(`Logged in as ${email}`);
              } else if (
                res.items?.is_2fa_enabled?.toLowerCase() == "yes".toLowerCase()
              ) {
                localStorage.setItem("isLoggedIn", "false");
                history.push({
                  pathname: `${
                    process.env.PUBLIC_URL
                  }/authentication/two-factor-authentication`,
                  state: { email, password },
                });
                setRedirect(true);
              } else {
                setRedirectUrl(`${process.env.PUBLIC_URL}/user/applications`);
                setIsLoginSuccess(true);
                setRedirect(true);
                toast.success(`Logged in as ${email}`);
                toast("Welcome to Sikka Software!");
                sessionStorage.setItem("s_u_d", JSON.stringify(tempSUD));
              }
            }
          } else if (res.items.is_partner === "0") {
            if (isApiPlusExist) {
              setRedirect(false);
              toast.error("User not found. Please check the information and try again.");
              setLoginApicalled(false);
              hideLoader();
              AuthService.logout(true,false);
            }else if (res.items.is_verified === "no") {
              setRedirectUrl(`${process.env.PUBLIC_URL}/user/verify`);
              setRedirect(true);
              toast.success(`Logged in as ${email}`);
            } else if (res.items.dev_status.toLowerCase() !== "active") {
              toast.error(
                "Your email id is already verified. Please contact Sikka API Support to get verified by Admin. Not allowed to log in."
              );
              AuthService.logout();
              setLoginApicalled(false);
              setRedirectUrl(`${process.env.PUBLIC_URL}/authentication/login`);
              sessionStorage.removeItem("s_u_d");
            } else {
              if (res.items.is_verified === "yes") {
                if (
                  res.items?.is_2fa_enabled?.toLowerCase() ==
                  "yes".toLowerCase()
                ) {
                  localStorage.setItem("isLoggedIn", "false");
                  history.push({
                    pathname: `${
                      process.env.PUBLIC_URL
                    }/authentication/two-factor-authentication`,
                    state: { email, password },
                  });
                  setRedirect(true);
                } else {
                  setRedirectUrl(`${process.env.PUBLIC_URL}/admin/dashboard`);
                  setIsLoginSuccess(true);
                  setRedirect(true);
                  toast.success(`Logged in as ${email}`);
                  toast("Welcome to Sikka Software!");
                  sessionStorage.setItem("s_u_d", JSON.stringify(tempSUD));
                }

                // setRedirectUrl(`${process.env.PUBLIC_URL}/admin/dashboard`);
                // setIsLoginSuccess(true);
                // setRedirect(true);
                // toast.success(`Logged in as ${email}`);
                // toast("Welcome to Sikka Software!");
                // sessionStorage.setItem("s_u_d", JSON.stringify(tempSUD));
              }
            }
          } else {
            setLoginApicalled(false);
            setRedirectUrl(`${process.env.PUBLIC_URL}/authentication/login`);
            sessionStorage.removeItem("s_u_d");
          }
          if (!isApiPlusExist) {  
            hideLoader();
          }
        },
        (error) => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          setLoginApicalled(false);
          hideLoader();
          //setLoading(false);
          //setMessage(resMessage);
          setIsLoginSuccess(false);
          toast.error(
            <div>
              {resMessage.split('\n').map((line, index) => {
                const trimmedLine = line.trim();
                return (
                  <div key={index} >
                    {trimmedLine.startsWith('Tip:') ? (
                      <strong style={{ fontWeight: 'bold', fontSize: '14px' }}>{trimmedLine}</strong>
                    ) : (
                      <span style={{ fontSize: '14px' }}>{trimmedLine}</span>
                    )}
                  </div>
                );
              })}
            </div>
          );
        }
      );
    } else {
      if (email == "") {
        toast.warn("Please enter username");
      }
      if (password == "") {
        toast.warn("Please enter password");
      }
    }
  };

  useEffect(() => {
    if (isLoginSuccess) {
      postVisitLogs();
    }
  }, [isLoginSuccess]);

  const HandleApiPlusApp = (selectedPayment,referralCode,loginUserDetails) => {
    let body = {
      username: loginUserDetails?.user_name,
    };
    const isApiPlusExist =
    loginUserDetails?.is_partner == "1" &&
    loginUserDetails.user_type?.toLowerCase() !== "User".toLowerCase()
      ? sessionStorage.getItem("api_plus_plus")
        ? JSON.parse(sessionStorage.getItem("api_plus_plus"))
        : false
      : false;

    if (isApiPlusExist) {
      body["redirect_url"] = isApiPlusExist["redirect_url"];
      body["callback_key"] = isApiPlusExist["callback_key"];
      body["request"] = isApiPlusExist["request"];
      body["referral_code_by"] = referralCode;
      body["project_id"] = isApiPlusExist["project_id"];
      body["steps"] = "use_default_payment";
      body["selected_payment_id"] = "";
      body["selected_profile_id"] = "";
      body["source_project_id"] = isApiPlusExist["source_project_id"] ? isApiPlusExist["source_project_id"] : "";
    };
    setLoginApicalled(true);
    showLoader();
      
    apiCall
      .servertrip(
        "POST",
        "api_plus_publish_app",
        loginUserDetails,
        undefined,
        body
      )
      .then((res) => {
        toast.success(res.data?.message);
        sessionStorage.removeItem("api_plus_plus");
        sessionStorage.removeItem("pastedLinkCount");
        setTimeout(() => {
          if (isApiPlusExist) {
            window.location.href = res.data?.url;
          }
        }, 2000);
      })
      .catch((error) => {
        const resMessage =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
        toast.error(resMessage);
      }).finally(()=>{
        setLoginApicalled(false);
        hideLoader();
      });
  };

  return (
    <AuthCardLayout bgProps={{ image: bgImage }}>
      <Row className={`text-left justify-content-between mb-2`}>
        <Col>
        {isApiPlusExist ?
          <>
            <Row className="text-center">
              <Col>
               <h3 className="mt-2 sai_light_text">Welcome Back!</h3>
              </Col> 
            </Row>  
            <Row className="text-center">
              <Col>
               <h6 className="mt-1 sai_secondary_text">Login into your dashboard</h6>
              </Col> 
            </Row>  
            <Row className="text-right">
              <Col>
                <p className={`fs--1 text-600`}> 
                  <Link to={`${process.env.PUBLIC_URL}/authentication/sai-register`} className={'sai_light_text text-underline'}>
                    Create an account
                  </Link>
                </p>
              </Col>  
            </Row>   
          </>
          : 
        <><h5>Log in</h5></>
        }
        </Col>
        {!isApiPlusExist && <Col xs="auto">
          <p className={`fs--1 text-600`}>
            or{" "}
            <Link to={`${process.env.PUBLIC_URL}/authentication/register`} className={'text-lowercase'}>
              Create an account
            </Link>
          </p>
        </Col>}
      </Row>
      <Form onSubmit={handleSubmit}>
        <FormGroup className="mb-3">
          {hasLabel && <Label>Email address</Label>}
          <Input
            placeholder={!hasLabel ? "Email address" : ""}
            // value={email}
            onChange={({ target }) => setEmail(target.value)}
            type="email"
          />
        </FormGroup>
        <FormGroup className="mb-3">
          {hasLabel && <Label>Password</Label>}
          <Input
            placeholder={!hasLabel ? "Password" : ""}
            // value={password}
            onChange={({ target }) => setPassword(target.value)}
            type="password"
          />
        </FormGroup>
        <Row className="justify-content-between align-items-center">
          <Col xs="auto">
            {/* <CustomInput
              id="customCheckRemember"
              label="Remember me"
              // defaultChecked={localStorage.getItem("remember")}
              checked={remember}
              onChange={({ target }) => {
                setRemember(!remember);
              }}
              type="checkbox"
            /> */}
          </Col>
          <Col xs="auto">
            <Link
              className={`fs--1  ${isApiPlusExist ? ' sai_light_text' : ' text-lowercase'}`}
              to={`${process.env.PUBLIC_URL}/authentication/forget-password`}
            >
              Forget password?
            </Link>
          </Col>
        </Row>
        <FormGroup className="mb-3">
          <Button block className={`mt-3 ${isApiPlusExist && ' sai_button'}`}>
            Log in
          </Button>
        </FormGroup>
      </Form>
      <Divider className="mt-4" />
      {loader}
      <Row>
        {/* <Button variant="" size="sm" className="btn-outline-google-plus mt-2 w-100">
              <Image src={APIReference} height={0} width={10} />
              API Reference
            </Button> */}
        <Row className="g-4 text-center text-md-start d-flex justify-content-center mt-4">
          <Col>
            <Link
              className="text-decoration-underline text-white fs--1"
              to={{ pathname: "https://apidocs.sikkasoft.com/" }}
              target="_blank"
            >
              <Col>
                <Avatar rounded={false} size="3xl" src={APIReference} />
                <h6 className="fs--1 text-800 fw-normal mb-3">API Reference</h6>
              </Col>
            </Link>
          </Col>
          <Col>
            <Link
              className="text-decoration-underline text-white fs--1"
              to={{ pathname: "https://apistatus.sikkasoft.com/" }}
              target="_blank"
            >
              <Col>
                <Avatar rounded={false} size="3xl" src={APIStatus} />
                <h6 className="fs--1 text-800 fw-normal mb-3">API Status</h6>
              </Col>
            </Link>
          </Col>
          <Col>
            <Link
              className="text-decoration-underline text-white fs--1"
              to={{ pathname: "https://sikka.ai/api-packages" }}
              target="_blank"
            >
              <Col>
                <Avatar rounded={false} size="3xl" src={API_Pricing_Image} />
                <h6 className="fs--1 text-800 fw-normal mb-3">API Pricing</h6>
              </Col>
            </Link>
          </Col>
        </Row>
      </Row>
    </AuthCardLayout>
  );
};

LoginForm.propTypes = {
  setRedirect: PropTypes.func.isRequired,
  layout: PropTypes.string,
  hasLabel: PropTypes.bool,
  setRedirectUrl: PropTypes.func.isRequired,
};

LoginForm.defaultProps = {
  hasLabel: false,
};

export default withRedirect(LoginForm);
